import { Route, Routes } from 'react-router-dom';
import DatasetManagementPage from './dataset-management';
import EditDataset from './edit-dataset'

const DatasetRouter: React.FC = () => {
  return(
  <Routes>
    <Route path='' element= {<DatasetManagementPage/>}/>
    <Route path=':id' element={<EditDataset/>}/>
  </Routes>
  )
}

export default DatasetRouter